module.exports = __webpack_public_path__ + "img/2.fa1feb99.jpg";